import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as L from 'leaflet';
import * as moment from 'moment';
import { CorrectionData, Corrections, GeometryResponse } from 'src/app/data/model/gps-address-data';
import { mapURL } from 'src/environments/environment.api';
import { WaypointsLapMapDialogService } from '../../services/waypoints-lap-map-dialog.service';
@Component({
  standalone: false,
  selector: 'app-waypoints-lap-map-dialog',
  templateUrl: './waypoints-lap-map-dialog.component.html',
  styleUrls: ['./waypoints-lap-map-dialog.component.scss']
})
export class WaypointsLapMapDialogComponent {

  constructor(
    private geoService: WaypointsLapMapDialogService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  @Output() map$: EventEmitter<L.Map>= new EventEmitter;
  @Output() zoom$: EventEmitter<number>=new EventEmitter;
  zoom!:number;
  public map!: L.Map;
  layer = new L.FeatureGroup();
  geo_loading$= this.geoService.loading$;
  geoRes:any;

 
  mapUrl = mapURL.mapUrl !== '${mapURL}' ? mapURL.mapUrl : mapURL.defaultMapUrl;
  @Input() options: L.MapOptions= {
      layers:[L.tileLayer(`${this.mapUrl}/styles/m2openmaptiles/{z}/{x}/{y}.png`, {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    })],
    zoom:7,
    center:L.latLng(43.300084381319905, 12.34134765625),
  };


  private decode(str: string, precision:number): L.LatLngExpression[]{
    var index = 0,
        lat = 0,
        lng = 0,
        coordinates:L.LatLng[] = [],
        shift = 0,
        result = 0,
        byte = null,
        latitude_change,
        longitude_change,
        factor = Math.pow(10, precision || 6);

    // Coordinates have variable length when encoded, so just keep
    // track of whether we've hit the end of the string. In each
    // loop iteration, a single coordinate is decoded.
    while (index < str.length) {

        // Reset shift, result, and byte
        byte = null;
        shift = 0;
        result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

        shift = result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

        lat += latitude_change;
        lng += longitude_change;
        const latitude=lat / factor
        const longitude=lng / factor
        coordinates.push(L.latLng(latitude, longitude));
    }

    return coordinates;
 }

 setIcon(type:String){
  if (type === 'start') {
    return L.Icon.extend({
      options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/start.png'
        }
      })
  } else if (type === 'stop') {
    return L.Icon.extend({
      options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/finish.png'
        }
      })
  } else {
    return L.Icon.extend({
      options:
      {
        iconSize: [21, 31], // size of the icon
        iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
        popupAnchor: [0, -51],  
        iconUrl: '../../../../assets/images/mark.png',
        shadowUrl: '../../../../assets/images/markshadow.png'
      }
      })
  }
}


  setWayPoints(markers: L.FeatureGroup, data:GeometryResponse){
    this.layer.clearLayers();
    const markerClusterGroup = L.markerClusterGroup();
    data.steps.forEach(step => {
      const [lat, lng] = step.street_coords;
      if (step.order === 0){
        const start_icon=this.setIcon('start');
        const marker = L.marker([lat, lng], {icon: new start_icon}).addTo(markerClusterGroup);
        marker.bindPopup(`<b>Indirizzo:</b> ${step.address} <b>Numero Ordine:</b> ${step.order}`);
      } else if (step.order === data.steps.length-1){
        const finish_icon=this.setIcon('stop');
        const marker = L.marker([lat, lng], {icon: new finish_icon}).addTo(markerClusterGroup);
        marker.bindPopup(`<b>Indirizzo:</b> ${step.address} <b>Numero Ordine:</b> ${step.order}`);
      }else {
        const icon=this.setIcon('standard');
        // Add marker at real_coords
        const marker = L.marker([lat, lng], {icon: new icon}).addTo(markerClusterGroup);
        marker.bindPopup(`<b>Indirizzo:</b> ${step.address} <b>Numero Ordine:</b> ${step.order}`);
      }
    });
    markerClusterGroup.addTo(markers)
    L.polyline(this.decode(data.geometry, 5), { color: 'blue' }).addTo(markers);
  }

  setDialogData(gps_lap: number){
    this.geoService.setLoading(true);
    var data: CorrectionData | undefined=undefined
    if(!data){
      data={
        gps_lap: gps_lap,
        corrections: [] as Corrections[],
        group: null
      }
    }
    this.geoService.orderPoints(data);
  }

  unsub(){
    this.geoRes.unsubscribe();
  }

  onMapReady(map: L.Map) {
      this.map = map;
      this.map$.emit(map);
      this.zoom = map.getZoom();
      this.zoom$.emit(this.zoom);
      this.setDialogData(this.data)
      this.geoRes=this.geoService.geometry_response$.subscribe((geometryResponse: GeometryResponse | null) => {
        if(geometryResponse) {
          geometryResponse.steps.sort((a, b) => a.order - b.order);
          this.setWayPoints(this.layer, geometryResponse);
        }
      })
      this.layer.addTo(this.map);
    }

  onMapZoomEnd(e: L.LeafletEvent) {
    this.zoom = e.target.getZoom();
    this.zoom$.emit(this.zoom);
  }
}

export type DialogMapParams = {
  data: any;
};
